module.exports = __webpack_public_path__ + "img/image02.ad5980dd.jpg";